import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "../../../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastService } from "@app/components/toastr/toast.service";

@Component({
  selector: "app-college-contact-create",
  templateUrl: "./college-contact-create.component.html",
  styleUrls: ["./college-contact-create.component.scss"],
})
export class CollegeContactCreateComponent implements OnInit {
  public tinyConfig = {
    base_url: '/assets/tinymce',
    suffix: '.min',
    height: 400,
    menubar: true,
    plugins: 'code table link image lists',
    apiKey: '',
    toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | bullist numlist | table | link image | code',
  };
  @Input() record: any;        // to receive record for edit
  @Input() collegeId: string;  // to receive college id from parent

  @Output() formSaved = new EventEmitter<void>(); // notify parent on save
  @Output() cancel = new EventEmitter<void>();
  @Input() isPopup: boolean = false;
  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;
  isShown: boolean = false;
  ownerships = [];
  colleges = [];


  constructor(
    private ActivatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private toast: ToastService
  ) { }

  public reg = "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?";

  ngOnInit() {
    this.Form = this.formBuilder.group({
      name: ["", Validators.required],
      designation: ["", [Validators.required]],
      college: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      alternateemail: ["", Validators.required],
      landlinenumber: ["", Validators.required],
      description: ["", Validators.required],
      mobilenumber: ["", Validators.required],
      alternumber: ["", Validators.required],
      status: ["", Validators.required],
      _id: [""],
    });

    this.action = "Submit";

    if (this.record && this.record._id) {
      // 🔹 Case 1: Opened in popup with existing record
      console.log("Popup editing contact ID:", this.record._id);

      this.Form.patchValue({
        ...this.record,
        _id: this.record._id
      });
      this.action = "Update";

    } else {
      // 🔹 Case 2: Opened via routed page
      this.ActivatedRoute.params.subscribe((params) => {
        const id = params["id"];
        if (!id) return;

        console.log("Routed contact ID:", id);

        this.http
          .get<any>(`${environment.apiUrl}/collegecontacts/${id}`, {
            headers: {
              Userinfo: JSON.stringify({
                _id: localStorage.getItem("adminSess"),
                role: localStorage.getItem("userRole"),
              }),
            },
          })
          .subscribe(
            (data) => {
              if (data && data._id) {
                this.action = "Update";
                this.Form.patchValue(data);
              }
            },
            (err: HttpErrorResponse) => {
              console.error("Error fetching contact by ID:", err);
            }
          );
      });

      // 🔹 Pre-fill college when adding a new one
      if (this.collegeId) {
        this.Form.patchValue({ college: this.collegeId });
      }
    }

    // 🔹 Common: load colleges for dropdown
    this.fetchColleges();
  }




  fetchColleges() {
    this.http
      .get<any>(`${environment.apiUrl}/college/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          if (data.message === "Logged Out!") {
            this.router.navigateByUrl("/auth/login");
            return;
          }
          this.colleges = data.results || data;
        },
        (err: HttpErrorResponse) => {
          console.error("Error loading colleges:", err);
        }
      );
  }


  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if (this.action == "Submit") {
      let data = {
        name: this.Form.value.name,
        designation: this.Form.value.designation,
        college: this.Form.value.college,
        email: this.Form.value.email,
        alternateemail: this.Form.value.alternateemail,
        description: this.Form.value.description,
        landlinenumber: this.Form.value.landlinenumber,
        mobilenumber: this.Form.value.mobilenumber,
        alternumber: this.Form.value.alternumber,
        status: this.Form.value.status,
      };
      console.log(data);

      this.http
        .post<any>(`${environment.apiUrl}/collegecontacts/`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (res) => {
            res.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Added";
              this.class = "btn-success rounded px-1 py-1";
              this.toast.show("Successfully Added", "success");
              this.router.navigateByUrl(
                "/college-details/college-contact-list"
              );
              this.formSaved.emit();
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
            this.toast.show("Failed to save address", "error");
          }
        );
    } else {
      let data = {
        name: this.Form.value.name,
        designation: this.Form.value.designation,
        college: this.Form.value.college,
        email: this.Form.value.email,
        alternateemail: this.Form.value.alternateemail,
        landlinenumber: this.Form.value.landlinenumber,
        mobilenumber: this.Form.value.mobilenumber,
        description: this.Form.value.description,
        alternumber: this.Form.value.alternumber,
        status: this.Form.value.status,
      };
      let id = this.Form.value._id;
      console.log(id);
      console.log(data);


      this.http
        .patch<any>(`${environment.apiUrl}/collegecontacts/${id}`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (res) => {
            res.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Updated";
              this.class = "btn-success rounded px-1 py-1";
              this.toast.show("Successfully Added", "success");

              if (this.isPopup) {
                this.formSaved.emit();  // ✅ popup refresh
              } else {
                this.router.navigateByUrl("/college-details/college-contact-list"); // ✅ page redirect
              }
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
            this.toast.show("Failed to save address", "error");
          }
        );
    }
  }
  onCancel() {
    if (this.cancel.observers.length > 0) {
      // 🔹 Case 1: Opened inside modal (popup)
      this.cancel.emit();
    } else {
      // 🔹 Case 2: Opened as a standalone routed page
      this.router.navigateByUrl("/college-details/college-contact-list");
    }
  }
}
